import { ScopeStamp } from '@/lib/scope-stamp';
import { getUserScope } from '@/lib/user-scope';
import { useGlobalQuery } from '@/state/query-client/hooks';
import { useAuthStore } from '@/state/store/auth';

/**
 * The signed-in user's own department, for showing or filtering by them on screen. It is
 * empty until the user's UserProfileDetail has loaded, so never stamp a new record from it: services
 * stamp records with `withUserScope` at insert time instead.
 */
export const useMyScope = (): ScopeStamp => {
  const authUserId = useAuthStore((state) => state.user?.itemId ?? '');
  const { data } = useGlobalQuery({
    queryKey: ['my-scope', authUserId],
    queryFn: () => getUserScope(authUserId),
    enabled: Boolean(authUserId),
    staleTime: 30 * 60 * 1000,
  });
  return data ?? {};
};
